import { useEffect, useState } from "react";
import styles from "./TokensOverlay.module.css";

import imgT1 from "../assets/images/tokenImages/t1.webp";
import imgT2 from "../assets/images/tokenImages/t2.webp";
import imgT3 from "../assets/images/tokenImages/t3.webp";
import imgT4 from "../assets/images/tokenImages/t4.webp";
import imgT5 from "../assets/images/tokenImages/t5.webp";

function TokensButton({
  img,
  priceST,
  priceGBP,
  originalPriceGBP,
  stripePriceId,
  user,
  disableButtons,
  setDisableButtons,
}) {
  const handlePurchase = async () => {
    if (disableButtons) return;
    if (!user) {
      const redirectUri = window.location.href;
      window.location.href = `https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/auth/steam?redirectUri=${encodeURIComponent(
        redirectUri
      )}`;
      return;
    }
    setDisableButtons(true);
    try {
      const res = await fetch(
        "https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/buy-steedie-tokens",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.jwt}`,
          },
          body: JSON.stringify({
            priceId: stripePriceId,
            redirectUri: window.location.href,
          }),
        }
      );

      if (res.ok) {
        const data = await res.json();
        window.location.href = data.url;
      } else {
        const error = await res.text();
        console.error("Error creating checkout session:", error);
        setDisableButtons(false);
      }
    } catch (err) {
      console.error(err);
      setDisableButtons(false);
    }
  };

  return (
    <button
      className={styles.tokensButton}
      onClick={handlePurchase}
      disabled={disableButtons}
    >
      <div className={styles.imgWrapper}>
        <img src={img} alt={priceST + "Tokens"} />
      </div>
      <div className={styles.footer}>
        <p>🪙{priceST}</p>
        <div className={styles.gbpPriceDiv}>
          {originalPriceGBP && (
            <s>
              <p>£{originalPriceGBP.toFixed(2)}</p>
            </s>
          )}
          <p>£{priceGBP}</p>
        </div>
      </div>
    </button>
  );
}

const TokensOverlay = ({ onClose, user }) => {
  const [disableButtons, setDisableButtons] = useState(false);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.panel}>
        <button className={styles.closeButton} onClick={onClose}>
          X
        </button>
        <div className={styles.buttonsRow}>
          <TokensButton
            img={imgT1}
            priceST={200}
            priceGBP={1.99}
            stripePriceId={"price_1RVxs0Djj3dUwkOaspurIQtD"}
            user={user}
            disableButtons={disableButtons}
            setDisableButtons={setDisableButtons}
          />
          <TokensButton
            img={imgT2}
            priceST={600}
            priceGBP={4.99}
            originalPriceGBP={(1.99 / 200) * 600}
            stripePriceId={"price_1RVxslDjj3dUwkOaH5ruq6dV"}
            user={user}
            disableButtons={disableButtons}
            setDisableButtons={setDisableButtons}
          />
          <TokensButton
            img={imgT3}
            priceST={1200}
            priceGBP={9.99}
            originalPriceGBP={(1.99 / 200) * 1200}
            stripePriceId={"price_1RVxtFDjj3dUwkOaZ1Tid3nI"}
            user={user}
            disableButtons={disableButtons}
            setDisableButtons={setDisableButtons}
          />
          <TokensButton
            img={imgT4}
            priceST={2400}
            priceGBP={19.99}
            originalPriceGBP={(1.99 / 200) * 2400}
            stripePriceId={"price_1RVxtbDjj3dUwkOaJ1AEt290"}
            user={user}
            disableButtons={disableButtons}
            setDisableButtons={setDisableButtons}
          />
          <TokensButton
            img={imgT5}
            priceST={5000}
            priceGBP={39.99}
            originalPriceGBP={(1.99 / 200) * 5000}
            stripePriceId={"price_1RVxu5Djj3dUwkOa4zhhBew8"}
            user={user}
            disableButtons={disableButtons}
            setDisableButtons={setDisableButtons}
          />
        </div>
      </div>
    </div>
  );
};

export default TokensOverlay;
